import { render, staticRenderFns } from "./BlockPanel.vue?vue&type=template&id=40483b80&scoped=true"
import script from "./BlockPanel.vue?vue&type=script&lang=js"
export * from "./BlockPanel.vue?vue&type=script&lang=js"
import style0 from "./BlockPanel.vue?vue&type=style&index=0&id=40483b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40483b80",
  null
  
)

export default component.exports